<template>
  <nav class="navegacion-desktop">
    <div class="ed-grid lg-grid-7">
      <router-link class="card lg-cols-3" :to="{ name: 'home' }">
        <img
          src="../img/logo-iQuela-blanco.svg"
          alt="iQuela"
          class="logo-iquela card"
        />
      </router-link>
      <router-link
        class="card link s-center navegacion-desktop__link-text"
        :to="{ name: 'proyectos-comunidad' }"
        >Comunidad</router-link
      >
      <router-link
        class="card link s-center navegacion-desktop__link-text"
        :to="{ name: 'blog' }"
        >Blog</router-link
      >
<!--       <router-link
        class="card link s-center navegacion-desktop__link-text"
        :to="{ name: 'planes' }"
        >Planes</router-link
      > -->

      <Button
        class="boton-secundario navegacion-desktop__boton card"
        label="Iniciar sesión"
        v-on:click.prevent="EnviarASesion"
      />
      <Button
        class="boton-primario navegacion-desktop__boton card"
        label="Registrarse"
        v-on:click.prevent="EnviarARegistro"
      />
    </div>
  </nav>
  <!-- nav para tablets -->
  <section class="navegacion-mobile ed-grid s-grid-2 full">
    <router-link class="card s-left" :to="{ name: 'home' }">
      <img
        src="../img/logo-iQuela-blanco.svg"
        alt="iQuela"
        class="logo-iquela"
      />
    </router-link>
    <img
      src="../img/barraNav/x.svg"
      alt="menu"
      class="card s-to-right navegacion-mobile__menu-img"
      v-on:click.prevent="toggleMenu"
      v-if="menu"
    />
    <img
      src="../img/barraNav/menu.svg"
      alt="menu"
      class="card s-to-right navegacion-mobile__menu-img"
      v-on:click.prevent="toggleMenu"
      v-else
    />

    <nav class="navegacion-mobile__nav" v-if="menu">
      <ul>
        <li class="navegacion-mobile__li-btn">
          <Button
            class="boton-primario navegacion-desktop__boton card"
            label="Regístrate"
            v-on:click.prevent="EnviarARegistro"
          />
        </li>
        <li class="navegacion-mobile__li-btn">
          <Button
            class="boton-secundario navegacion-desktop__boton card"
            label="Iniciar sesión"
            v-on:click.prevent="EnviarASesion"
          />
        </li>
        <li>
          <router-link
            class="card link s-center navegacion-desktop__link-text"
            :to="{ name: 'proyectos-comunidad' }"
            >Comunidad</router-link
          >
        </li>
        <li>
          <router-link
            class="card link s-center navegacion-desktop__link-text"
            :to="{ name: 'blog' }"
            >Blog</router-link
          >
        </li>
<!--         <li>
          <router-link
            class="card link s-center navegacion-desktop__link-text"
            :to="{ name: 'planes' }"
            >Planes</router-link
          >
        </li> -->
      </ul>
    </nav>
  </section>
  <router-view />
</template>
<script>
import Button from "primevue/button";
import router from "../router";
import { ref } from "vue";

export default {
  setup() {
    const EnviarARegistro = () => {
      router.push({ name: "registro" });
    };
    const EnviarASesion = () => {
      router.push({ name: "iniciar-sesion" });
    };

    let menu = ref(false);
    function toggleMenu() {
      menu.value = !menu.value;
    }
    return {
      EnviarARegistro,
      EnviarASesion,
      menu,
      toggleMenu,
    };
  },
  components: {
    Button,
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/navegacion.scss";
</style> 
